import React, { Component } from "react";
import {
  CBadge,
  CCardText,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CHeaderNavLink,
  CImg,
  CSelect,
  CLabel,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import config from "../config/config";
import axios from "axios";
import { cibSonos, cilWindowRestore } from "@coreui/icons";

class TheHeaderDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: JSON.parse(localStorage.getItem("userData")),
      userToken: localStorage.getItem("userToken"),
      islogin: Boolean(localStorage.getItem("islogin")),
      selected_vehicle: "",
      vehicle_type_array: [],
      vehicle_type_config: config.vehicle_type_array,
    };
    this.changeParameters = this.changeParameters.bind(this);
    this.switchVehicle = this.switchVehicle.bind(this);
  }

  componentDidMount() {
    if (
      this.state.userData &&
      this.state.userToken &&
      this.state.islogin == true &&
      this.state.userData.vehicle_type &&
      this.state.userData.vehicle_type != ""
    ) {
      let vehicle_type_array_split = [];
      let vehicle_type_array_map = [];
      vehicle_type_array_split = this.state.userData.vehicle_type.split(",");

      if (vehicle_type_array_split.length > 0) {
        vehicle_type_array_split.map((veh) => {
          vehicle_type_array_map[veh] = this.state.vehicle_type_config[veh];
        });
      }

      this.setState({
        vehicle_type_array: vehicle_type_array_map,
        selected_vehicle:
          vehicle_type_array_map[
            vehicle_type_array_map.findIndex(
              (element) => typeof element !== "undefined"
            )
          ],
      });

      if (
        this.state.userData.selected_vehicle_type &&
        this.state.userData.selected_vehicle_type != ""
      ) {
        this.setState({
          selected_vehicle:
            vehicle_type_array_map[
              parseInt(this.state.userData.selected_vehicle_type)
            ],
        });
      } else {
        this.setState({
          selected_vehicle:
            vehicle_type_array_map[
              vehicle_type_array_map.findIndex(
                (element) => typeof element !== "undefined"
              )
            ],
        });
      }
    } else {
      console.log(
        "userData not found in local storage after login,redirecting to login page"
      );
      window.location.hash = "/login";
    }
  }

  changeParameters(e) {
    if (e) {
      var name = e.target.name;
      var val = e.target.value;
      let selectd_veh_ID;

      if (name === "vehicleType") {
        this.setState({
          selected_vehicle: val,
        });

        /*Changing vehicle string to vehicle id */
        this.state.vehicle_type_array.map((element, index) => {
          if (element === val) {
            selectd_veh_ID = index;
          }
        });

        if (
          this.state.userData &&
          this.state.userToken &&
          this.state.islogin == true &&
          this.state.userData != null &&
          this.state.userToken != ""
        ) {
          this.switchVehicle(selectd_veh_ID);
        }
      }
    } else {
      console.log("no event occured, redirecting to login");
      window.location.hash = "/login";
    }
  }

  switchVehicle = async (selectd_veh_ID) => {
    /*check on vehicle change*/
    const token = this.state.userToken;
    const APIURL = config.API_URL + "/user/switchVehType";
    var bearer = token;
    await axios
      .post(
        APIURL,
        { selected_vehicle: selectd_veh_ID },
        { headers: { Authorization: bearer } }
      )
      .then((r) => {
        if (r.status == 200) {
          /*check on response received*/
          if (
            r.data.userData &&
            r.data.userData != null &&
            r.data.userToken &&
            r.data.userToken != ""
          ) {
            // console.log(r.data.userData);
            localStorage.setItem("userData", JSON.stringify(r.data.userData));
            localStorage.setItem("userToken", r.data.userToken);
            this.setState({
              userData: JSON.parse(localStorage.getItem("userData")),
              userToken: localStorage.getItem("userToken"),
            });
            window.location.reload(true);
          }
        }
      });
  };

  logout() {
    localStorage.clear();
    window.location.href = "/";
  }

  render() {
    return (
      <>
        {/* vehicle section */}
        <CLabel htmlFor="vehicleType" className="px-3 my-auto font-weight-bold">
          Vehicle
        </CLabel>

        <CSelect
          className=""
          id="vehicleType"
          name="vehicleType"
          value={this.state.selected_vehicle}
          onChange={(e) => this.changeParameters(e)}
        >
          <option value={this.state.selected_vehicle}>
            {this.state.selected_vehicle}
          </option>
          {this.state.vehicle_type_array.map((element, index) => {
            if (
              typeof element !== "undefined" &&
              element !== this.state.selected_vehicle
            ) {
              return (
                <option key={index} value={element}>
                  {element}
                </option>
              );
            }
          })}
        </CSelect>

        {/* user section */}
        <CDropdown inNav className="c-header-nav-items mx-3" direction="down">
          {this.state.userData && this.state.userData.name ? (
            <CDropdownToggle color="primary" className="c-header-nav-link">
              <CHeaderNavLink> {this.state.userData.name} </CHeaderNavLink>
              <div className="c-avatar">
                <CImg src={"avatars/6.jpg"} className="c-avatar-img" />
              </div>
            </CDropdownToggle>
          ) : (
            "null"
          )}

          <CDropdownMenu className="pt-0" placement="bottom-end">
            <CDropdownItem onClick={this.logout}>
              <CIcon name="cil-lock-locked" className="mfe-4" />
              Logout
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </>
    );
  }
}
export default TheHeaderDropdown;

{
  /*
<CDropdownItem>
          <CIcon name="cil-bell" className="mfe-2" /> 
          Updates
          <CBadge color="info" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-envelope-open" className="mfe-2" /> 
          Messages
          <CBadge color="success" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-task" className="mfe-2" /> 
          Tasks
          <CBadge color="danger" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-comment-square" className="mfe-2" /> 
          Comments
          <CBadge color="warning" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem
          header
          tag="div"
          color="light"
          className="text-center"
        >
          <strong>Settings</strong>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-user" className="mfe-2" />Profile
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-settings" className="mfe-2" /> 
          Settings
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-credit-card" className="mfe-2" /> 
          Payments
          <CBadge color="secondary" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-file" className="mfe-2" /> 
          Projects
          <CBadge color="primary" className="mfs-auto">42</CBadge>
        </CDropdownItem>


  <CDropdownItem
          header
          tag="div"
          color="light"
          className="text-center"
        >
          <strong>Account</strong>
        </CDropdownItem>
                <CDropdownItem divider />


        */
}

